import React, {Component} from 'react';

class Counts extends Component{
    render(){
        return(
            <section className="count-section">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-lg-12">
                        <div className="row">
                            <div className="col-12 col-md-3">
                                <div className="count-box text-center">
                                    <h3>12,345</h3>
                                    <p className="mb-0">Faculty Memeber</p>
                                </div>
                            </div>
                            <div className="col-12 col-md-3">
                                <div className="count-box text-center">
                                    <h3>110</h3>
                                    <p className="mb-0">Faculty</p>
                                </div>
                            </div>
                            <div className="col-12 col-md-3">
                                <div className="count-box text-center">
                                    <h3>20</h3>
                                    <p className="mb-0">Year of Experince</p>
                                </div>
                            </div>
                            <div className="col-12 col-md-3">
                                <div className="count-box text-center">
                                    <h3>2000</h3>
                                    <p className="mb-0">Year of establishment</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>				
        </section>
       
        );
    }
}

export default Counts;
	
    